import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./MatriculaModal.css";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { useContext, useState } from "react";
import {
  guardarDatosMatricula,
  limpiarMatriculaMedico,
  resetKinesioFlag,
  wsGetMatriculaMedico,
  wsLimpiarMatriculaMedico,
  wsPutMedicoSolicitante,
  wsPutMedicoSolicitanteLaboratorio,
  wsSolicitarDatosMedico,
} from "../../../context/Actions/turnos/turnosPaciente";
import { PortalContext } from "../../../context/Provider";
import camelize from "../../../../global/utils/camelize";
import { hideModal } from "../../../context/Actions/modal/modal";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";

const MatriculaModal = ({
  titulo,
  dissmiss,
  idturno,
  idProtocolo,
  modalDatosMedico,
}) => {
  const {
    turnosPacienteDispatch,
    turnosPacienteState,
    modalDispatch,
    selectDropDownState,
  } = useContext(PortalContext);
  const { toasterDispatch } = useContext(GlobalContext);
  const [matriculaMed, setMatriculaMed] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);

  const onNombreChange = (e) => {
    if (e.target.value.length > 0) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
    var matString = e.target.value.toString();
    setMatriculaMed(matString);
  };

  const seleccionarMatricula = (e) => {
    if (turnosPacienteState.turnosPaciente.error === false) {
      wsGetMatriculaMedico(
        matriculaMed,
        turnosPacienteState.turnosPaciente.data,
        idturno
      )(turnosPacienteDispatch);
      if (idProtocolo > 0) {
        if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
          wsPutMedicoSolicitanteLaboratorio(
            idProtocolo,
            e[0].codigo,
            selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
          )(turnosPacienteDispatch);
        } else {
          wsPutMedicoSolicitanteLaboratorio(
            idProtocolo,
            e[0].codigo,
            false
          )(turnosPacienteDispatch);
        }
      } else {
        if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
          wsPutMedicoSolicitante(
            idturno,
            e[0].codigo,
            selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
            asignarMatricula
          )(turnosPacienteDispatch);
        } else {
          wsPutMedicoSolicitante(
            idturno,
            e[0].codigo,
            false,
            asignarMatricula
          )(turnosPacienteDispatch);
        }
      }
      hideModal()(modalDispatch);
      wsSolicitarDatosMedico(
        e[0].codigo,
        modalDatosMedico
      )(turnosPacienteDispatch);
    }
  };

  const buscarPorMatricula = () => {
    guardarDatosMatricula(matriculaMed, checkMatricula)(turnosPacienteDispatch);
  };

  const checkMatricula = (isCorrect, data) => {
    if (!isCorrect) {
      showToaster(
        {
          texto: data?.userMessage || "Error al buscar matricula",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      wsLimpiarMatriculaMedico(
        turnosPacienteState.turnosPaciente.data,
        idturno
      )(turnosPacienteDispatch);
      limpiarMatriculaMedico()(turnosPacienteDispatch);
      resetKinesioFlag()(turnosPacienteDispatch);
    }
  };

  const asignarMatricula = (isCorrect) => {
    if (isCorrect) {
      showToaster(
        {
          texto: "Matricula agregada correctamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      limpiarMatriculaMedico()(turnosPacienteDispatch);
    } else {
      showToaster(
        {
          texto: "Error al asignar matricula",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const limpiarMatricula = () => {
    limpiarMatriculaMedico()(turnosPacienteDispatch);
    setMatriculaMed(false);
    setBtnDisabled(true);
  };

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-matriculaModal-container">
        <div className="ptur-matriculaModal-body">
          {turnosPacienteState.turnosPaciente.matriculaMedico !== null &&
          turnosPacienteState.turnosPaciente.matriculaMedico !== "" ? (
            <>
              <p className="ptur-matriculaModal-texto rb18l">
                Seleccione el <span className="rb18b">profesional</span> que
                corresponda
              </p>
              <div className="ptur-matriculaModal-card">
                <div className="ptur-matriculaModal-titulo">
                  <p className="rb18b">
                    {camelize(
                      turnosPacienteState.turnosPaciente.matriculaMedico[0]
                        .nombre
                    )}
                  </p>
                </div>
                <div className="ptur-matriculaModal-btn-body">
                  <div className="ptur-matriculaModal-card-cuerpo">
                    {turnosPacienteState.turnosPaciente.matriculaMedico[0]
                      .matriculaNacional === null ||
                    turnosPacienteState.turnosPaciente.matriculaMedico[0]
                      .matriculaNacional === "" ? (
                      ""
                    ) : (
                      <li className="ptur-matriculaModal-matricula">
                        M. Nacional:{" "}
                        <span className="rb16b">
                          {
                            turnosPacienteState.turnosPaciente
                              .matriculaMedico[0].matriculaNacional
                          }
                        </span>
                      </li>
                    )}
                    {turnosPacienteState.turnosPaciente.matriculaMedico[0]
                      .matriculaProvincial === null ||
                    turnosPacienteState.turnosPaciente.matriculaMedico[0]
                      .matriculaProvincial === "" ? (
                      ""
                    ) : (
                      <li className="ptur-matriculaModal-matricula">
                        M. Provincial:{" "}
                        <span className="rb16b">
                          {
                            turnosPacienteState.turnosPaciente
                              .matriculaMedico[0].matriculaProvincial
                          }
                        </span>
                      </li>
                    )}
                  </div>
                  <div className="ptur-matriculaModal-BtnCont">
                    <div>
                      <button
                        className="ptur-matriculaModal-seleccionarBtn bgc-primary c-white rb16m"
                        onClick={() =>
                          seleccionarMatricula(
                            turnosPacienteState.turnosPaciente.matriculaMedico
                          )
                        }
                      >
                        Seleccionar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ptur-matriculaModal-botonesCont">
                <div>
                  <button
                    className="ptur-matriculaModal-volverBtn bgc-danger c-white rb16m"
                    onClick={limpiarMatricula}
                  >
                    Volver
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <p className="ptur-matriculaModal-texto rb18l">
                Le pedimos que{" "}
                <span className="rb18b">ingrese la matrícula</span> del médico
                que se encuentra en el sello de la orden
              </p>
              <div>
                <InputV1
                  inputType="text"
                  name="txtNombre"
                  placeholderText="12254"
                  errorStr="El nombre es requerido"
                  onChange={onNombreChange}
                  maxLength="7"
                  className="rb16m"
                  isRequired={true}
                />
              </div>
              <div className="ptur-matriculaModal-botonesCont">
                <div>
                  <button
                    className={
                      btnDisabled
                        ? "ptur-matriculaModal-buscarBtn bgc-grey65 c-white rb16m"
                        : "ptur-matriculaModal-buscarBtn bgc-latex30 c-white rb16m"
                    }
                    onClick={buscarPorMatricula}
                    disabled={btnDisabled}
                  >
                    Buscar Médico
                  </button>
                </div>
                {turnosPacienteState.turnosPaciente.ultimoTurno ? (
                  <div>
                    <button
                      className="ptur-matriculaModal-cerrarBtn bgc-white c-latex30 rb16m"
                      onClick={dissmiss}
                    >
                      Ingresar Después
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default MatriculaModal;
